import { encodedStringParser, stringParser } from '../inboundParsers';
export const LEAVE_LOBBY_PLAYER_PAYLOAD_DEFINITION = {
    definitionParts: [
        { name: 'sessionId', parser: stringParser },
        { name: 'lobbyLeaveMessageTemplate', parser: encodedStringParser }
    ]
};
